export default __webpack_public_path__ + "static/media/Profile2.db9c4cdc.svg";